export default __webpack_public_path__ + "static/media/realestate-bathroom.e3af7810.svg";